import actions from "./account-actions";
import getters from "./account-getters";
import mutations from "./account-mutations";
import defaultState from "./account-state";
const accountStore = {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
  getters
};
export default accountStore;